import React from "react";
import { Scrollbars } from "react-custom-scrollbars";

const CustomScrollbars = (props) => <Scrollbars  {...props} autoHide
    style={{ overflowX: 'hidden !important' }} />;

export default CustomScrollbars;
